import { Component, OnInit } from '@angular/core';

import { ScreenService } from '../services/screen.service';

@Component({
  selector: 'fw-title-bar',
  template: require('./title-bar.component.html'),
  styles: [require('./title-bar.component.css')]
})
export class TitleBarComponent implements OnInit {

  constructor(private screenService: ScreenService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/title-bar/title-bar.component.ts